// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══ ADDITIVE AUTOCOMPLETE ════════════════════════════════════════════════ */
.additive-inline-search {
  position: relative;
  display: inline-block;
}

.additive-search-input {
  width: 220px;
}

.additive-dropdown {
  position: absolute;
  z-index: 1050;
  top: 100%;
  left: 0;
  background: #fff;
  border: 1px solid #ced4da;
  border-top: none;
  border-radius: 0 0 4px 4px;
  list-style: none;
  padding: 0;
  margin: 0;
  min-width: 220px;
  max-height: 200px;
  overflow-y: auto;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
}

.additive-dropdown li {
  padding: 5px 10px;
  cursor: pointer;
  font-size: 0.875rem;
  white-space: nowrap;
}

.additive-dropdown li:hover {
  background-color: #e9ecef;
}

/* ═══ DATA-GRID MATERIAL SECTIONS ══════════════════════════════════════════ */
.blend-section {
  margin: 6px 0 12px 0;
}

.blend-header {
  font-weight: 600;
  color: #0b2d71;
  font-size: 12px;
  margin-bottom: 6px;
  padding: 3px 0;
}

.material-cell {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 2px 4px;
}

.material-name {
  font-size: 11px;
  white-space: nowrap;
}

.material-select {
  width: 100%;
  padding: 3px 6px;
  border: 1px solid #aaa;
  font-size: 11px;
  background: white;
}

.numeric-input {
  width: 100%;
  padding: 3px 6px;
  border: none;
  font-size: 11px;
  text-align: center;
  box-sizing: border-box;
  background: transparent;
}

.numeric-input.input-invalid {
  border: 2px solid #e74c3c !important;
  border-radius: 3px;
  background: #fff;
}

.form-control.input-invalid {
  border-color: #e74c3c !important;
  box-shadow: none;
}

.container-input {
  flex: 1;
  padding: 3px 6px;
  border: none;
  font-size: 11px;
  text-align: center;
  box-sizing: border-box;
  background: transparent;
  min-width: 0;
}

.table-container-cell {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
}

.table-edit-btn {
  flex: 0 0 auto;
  padding: 2px 8px;
  font-size: 11px;
  line-height: 1.4;
  white-space: nowrap;
}

.delete-btn {
  color: #c0392b;
  font-weight: bold;
  padding: 0 4px;
  line-height: 1;
  font-size: 12px;
  border: none;
  background: transparent;
}

.delete-btn:hover {
  color: #a93226;
}

/* ═══ SPINNER OVERLAY ═════════════════════════════════════════════════════ */
.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.6);
  z-index: 9999;
}

/* ═══ TABS ════════════════════════════════════════════════════════════════ */
.tabs li[aria-selected="true"] {
  color: #0b2d71 !important;
  font-weight: 600;
  border: 4px solid #fff;
  border-width: 0 0 4px;
  border-bottom: #0b2d71 4px solid;
}

div.tabbed > ul.tabs {
  margin: 0;
  padding: 0;
  text-align: left;
}

.tab-content {
  display: block;
}

.tab-content[aria-hidden="true"] {
  display: none;
}

/* ═══ MATERIALS SECTION ════════════════════════════════════════════════════ */
.materials-section {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 1rem;
  background-color: #f8f9fa;
}

.section-title {
  color: #0b2d71;
  font-size: 1.1rem;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #0b2d71;
}

/* ═══ MISC ════════════════════════════════════════════════════════════════ */
.breadcrumb-link {
  color: #0b2d71;
  text-decoration: none;
}

.breadcrumb-link:hover {
  text-decoration: underline;
}

.header-info-strip {
  background-color: #f8f9fa;
}

.small-icon {
  font-size: 16px;
  line-height: 16px;
  width: 16px;
  height: 16px;
}

.input-group .btn {
  padding: 0.25rem 0.5rem;
}

.form-control-sm {
  font-size: 0.85rem;
  padding: 0.25rem 0.5rem;
}

textarea.form-control {
  resize: vertical;
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/spacer-details/spacer-details.component.css"],"names":[],"mappings":"AAAA,+EAA+E;AAC/E;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+EAA+E;AAC/E;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,eAAe;EACf,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA,8EAA8E;AAC9E;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,aAAa;AACf;;AAEA,8EAA8E;AAC9E;EACE,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,+EAA+E;AAC/E;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,8EAA8E;AAC9E;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* ═══ ADDITIVE AUTOCOMPLETE ════════════════════════════════════════════════ */\n.additive-inline-search {\n  position: relative;\n  display: inline-block;\n}\n\n.additive-search-input {\n  width: 220px;\n}\n\n.additive-dropdown {\n  position: absolute;\n  z-index: 1050;\n  top: 100%;\n  left: 0;\n  background: #fff;\n  border: 1px solid #ced4da;\n  border-top: none;\n  border-radius: 0 0 4px 4px;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  min-width: 220px;\n  max-height: 200px;\n  overflow-y: auto;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);\n}\n\n.additive-dropdown li {\n  padding: 5px 10px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  white-space: nowrap;\n}\n\n.additive-dropdown li:hover {\n  background-color: #e9ecef;\n}\n\n/* ═══ DATA-GRID MATERIAL SECTIONS ══════════════════════════════════════════ */\n.blend-section {\n  margin: 6px 0 12px 0;\n}\n\n.blend-header {\n  font-weight: 600;\n  color: #0b2d71;\n  font-size: 12px;\n  margin-bottom: 6px;\n  padding: 3px 0;\n}\n\n.material-cell {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 2px 4px;\n}\n\n.material-name {\n  font-size: 11px;\n  white-space: nowrap;\n}\n\n.material-select {\n  width: 100%;\n  padding: 3px 6px;\n  border: 1px solid #aaa;\n  font-size: 11px;\n  background: white;\n}\n\n.numeric-input {\n  width: 100%;\n  padding: 3px 6px;\n  border: none;\n  font-size: 11px;\n  text-align: center;\n  box-sizing: border-box;\n  background: transparent;\n}\n\n.numeric-input.input-invalid {\n  border: 2px solid #e74c3c !important;\n  border-radius: 3px;\n  background: #fff;\n}\n\n.form-control.input-invalid {\n  border-color: #e74c3c !important;\n  box-shadow: none;\n}\n\n.container-input {\n  flex: 1;\n  padding: 3px 6px;\n  border: none;\n  font-size: 11px;\n  text-align: center;\n  box-sizing: border-box;\n  background: transparent;\n  min-width: 0;\n}\n\n.table-container-cell {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  width: 100%;\n}\n\n.table-edit-btn {\n  flex: 0 0 auto;\n  padding: 2px 8px;\n  font-size: 11px;\n  line-height: 1.4;\n  white-space: nowrap;\n}\n\n.delete-btn {\n  color: #c0392b;\n  font-weight: bold;\n  padding: 0 4px;\n  line-height: 1;\n  font-size: 12px;\n  border: none;\n  background: transparent;\n}\n\n.delete-btn:hover {\n  color: #a93226;\n}\n\n/* ═══ SPINNER OVERLAY ═════════════════════════════════════════════════════ */\n.spinner-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.6);\n  z-index: 9999;\n}\n\n/* ═══ TABS ════════════════════════════════════════════════════════════════ */\n.tabs li[aria-selected=\"true\"] {\n  color: #0b2d71 !important;\n  font-weight: 600;\n  border: 4px solid #fff;\n  border-width: 0 0 4px;\n  border-bottom: #0b2d71 4px solid;\n}\n\ndiv.tabbed > ul.tabs {\n  margin: 0;\n  padding: 0;\n  text-align: left;\n}\n\n.tab-content {\n  display: block;\n}\n\n.tab-content[aria-hidden=\"true\"] {\n  display: none;\n}\n\n/* ═══ MATERIALS SECTION ════════════════════════════════════════════════════ */\n.materials-section {\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  padding: 1rem;\n  background-color: #f8f9fa;\n}\n\n.section-title {\n  color: #0b2d71;\n  font-size: 1.1rem;\n  margin-bottom: 1rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 2px solid #0b2d71;\n}\n\n/* ═══ MISC ════════════════════════════════════════════════════════════════ */\n.breadcrumb-link {\n  color: #0b2d71;\n  text-decoration: none;\n}\n\n.breadcrumb-link:hover {\n  text-decoration: underline;\n}\n\n.header-info-strip {\n  background-color: #f8f9fa;\n}\n\n.small-icon {\n  font-size: 16px;\n  line-height: 16px;\n  width: 16px;\n  height: 16px;\n}\n\n.input-group .btn {\n  padding: 0.25rem 0.5rem;\n}\n\n.form-control-sm {\n  font-size: 0.85rem;\n  padding: 0.25rem 0.5rem;\n}\n\ntextarea.form-control {\n  resize: vertical;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
